module.exports = __webpack_public_path__ + "img/logo.f38f39d6.png";